import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { IAvailability } from 'interfaces/profile.interface';
import React, { FC } from 'react';
import { formatWeight } from 'utils';

const CurrentCapacity: FC<IAvailability> = ({ currentCapacity, totalCapacity, timeSinceCollected }) => (
  <>
    {currentCapacity && totalCapacity && (
      <GenericInfoItem title="Capacidade disponível aproximada">
        <>
          <FuelFlex defaultProps={{ alignItems: 'flex-end', gap: 'km1' }}>
            <FuelTypography weight="medium">{formatWeight(currentCapacity)}</FuelTypography>
            <FuelTypography size="caption" weight="medium" color="neutral-default">
              {'/ '}
              {formatWeight(totalCapacity, false)}
            </FuelTypography>
          </FuelFlex>
          <FuelTypography size="caption" weight="medium" color="neutral-default">
            Há {timeSinceCollected}
          </FuelTypography>
        </>
      </GenericInfoItem>
    )}
  </>
);

export default CurrentCapacity;
